import React from 'react';

import { Flex, Link } from 'src/kit';
import { TabWrapper } from '../atoms/TabWrapper';

const tabs = [
  { text: 'Jobs', href: '/jobs' },
  { text: 'Explore', href: '/explore' },
  { text: 'Resources', href: '/resources' }
];

export function Tabs({ activeIndex }: { activeIndex: number }) {
  return (
    <Flex width="100%" alignItems="center" justifyContent="space-between" flexWrap={{ xs: 'wrap', xl: 'nowrap' }}>
      {tabs.map(({ text, href }, i) => (
        <TabWrapper as={Link} to={href} background={i === activeIndex ? '#e3effe' : 'transparent'} key={text}>
          {text}
        </TabWrapper>
      ))}
    </Flex>
  );
}
